import { render, staticRenderFns } from "./AdvancedSetup.vue?vue&type=template&id=2265cac8&"
import script from "./AdvancedSetup.vue?vue&type=script&lang=js&"
export * from "./AdvancedSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports